import { combineReducers } from 'redux'

import hcpTableDataReducer from './admin/hcpTableDataReducer'
import clinicTableDataReducer from './admin/clinicTableDataReducer'
import mediatorTableDataReducer from './admin/mediatorTableDataReducer'
import adminTableDataReducer from './admin/adminTableDataReducer'
import patientsTableDataReducer from './doctor/patientTableDataReducer'
import patientRequestsTableDataReducer from './doctor/patientRequestsTableDataReducer'
import patientClosedRequestsTableDataReducer from './doctor/patientClosedRequestsTableDataReducer'

export default combineReducers({
    mediatorTableDataReducer,
    hcpTableDataReducer,
    clinicTableDataReducer: clinicTableDataReducer,
    patientRequestsTableDataReducer,
    patientClosedRequestsTableDataReducer,
    adminTableDataReducer,
    patientsTableDataReducer,
})
